import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.error-market', {
        url: '/errorMarket/:domain?error_code',
        component: 'googleMarketplaceConfigurationError',
        resolve: {errorCode},
    });
}

/** @ngInject */
function errorCode($stateParams) {
    return $stateParams.error_code;
}



// WEBPACK FOOTER //
// ./src/portal/states/public/google-marketplace-configuration-error/google-marketplace-configuration-error.state.js